import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import {
  ADMIN_AFFILIATES_APPROVED_ROUTE_NAME,
} from '@modules/affiliates-approved/constants';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import { PostbacksEditModule } from '@modules/postbacks/submodules/edit/PostbacksEditModule';
import {
  AFFILIATE_TRACKING_LINKS_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  ADMIN_POSTBACKS_LIST_ROUTE_NAME,
  ADMIN_POSTBACKS_ROUTE_NAME,
  AFFILIATE_POSTBACKS_LIST_ROUTE_NAME,
  AFFILIATE_POSTBACKS_ROUTE_NAME,
  POSTBACKS_PERMISSIONS,
  TRANSLATION_GROUP_POSTBACKS,
} from './constants';
import { getTranslationKeys } from './translations';

export class PostbacksModule extends AppModule {
  protected submodules = [
    new PostbacksEditModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAffiliateRoute({
      name: AFFILIATE_POSTBACKS_ROUTE_NAME,
      path: 'webhooks',
      permission: POSTBACKS_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'PostbacksListPage',
    });

    router.addChildRoute(AFFILIATE_POSTBACKS_ROUTE_NAME, {
      name: AFFILIATE_POSTBACKS_LIST_ROUTE_NAME,
      path: ':type',
      permission: POSTBACKS_PERMISSIONS.SHOW,
      component: () => import('./pages/PostbacksListPage/PostbacksListPage.vue'),
    });

    router.addChildRoute(ADMIN_AFFILIATES_APPROVED_ROUTE_NAME, {
      name: ADMIN_POSTBACKS_ROUTE_NAME,
      path: 'webhooks/:id',
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      props: {
        keepAliveInclude: 'PostbacksListPage',
      },
    });

    router.addChildRoute(ADMIN_POSTBACKS_ROUTE_NAME, {
      name: ADMIN_POSTBACKS_LIST_ROUTE_NAME,
      path: ':type',
      permission: POSTBACKS_PERMISSIONS.SHOW,
      component: () => import('./pages/PostbacksListPage/PostbacksListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAffiliateMenuItem(AFFILIATE_TRACKING_LINKS_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'TRACKING_LINKS_WEBHOOKS'),
      to: {
        name: AFFILIATE_POSTBACKS_LIST_ROUTE_NAME,
        params: {
          type: 'registration',
        },
      },
      permission: POSTBACKS_PERMISSIONS.SHOW,
      id: AFFILIATE_POSTBACKS_LIST_ROUTE_NAME,
      order: 30,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_POSTBACKS, getTranslationKeys);
  }
}
